import { useCallback } from "react";
import Logger from "../utils/logger";
import { showErrorToast } from "../utils/show-toast";

function useNativeShare() {
  const share = useCallback(async (data?: ShareData) => {
    if (!navigator?.share) {
      showErrorToast("Not supported");
      return;
    }

    try {
      await navigator.share(data);
    } catch (e) {
      Logger.error(e);
      showErrorToast("Could not complete sharing");
    }
  }, []);

  return share;
}

export default useNativeShare;
